import request from '@/utils/request'
import qs from 'qs'

// 列表
export const getLogList = (params) => {
  return request({
    url: '/api/businessLog',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

//获取操作类型
export const getLogType = () => {
    return request({
      url: '/api/businessLog/type',
      method: 'GET'
    })
}

// 获取所有模块名称
export const getModuleList = () => {
  return request({
    url: '/api/businessLog/moduleName',
    method: 'GET'
  })
}
// 获取所有企业名称
export const getCompanyList = () => {
  return request({
    url: '/api/company',
    method: 'GET'
  })
}